import { render, staticRenderFns } from "./SalesQuoteList.vue?vue&type=template&id=dd0e2988&scoped=true&"
import script from "./SalesQuoteList.vue?vue&type=script&lang=js&"
export * from "./SalesQuoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0e2988",
  null
  
)

export default component.exports